import { HttpStatus } from "./httpStatus";

export type APIErrorType = {
    statusCode: HttpStatus;
    errorCode: string;
    message: string;
    data?: Partial<{
        blockUntilDate?: number;
    }>; // TODO: for Validation Pipe, etc...
};

export type APIErrorsType = { [key: string]: APIErrorType };

// TODO: Type safeにしなければいけない問題があるが、ベストプラクティスを考えるまで保留
export const EmailLoginAPIErrors = {
    BLOCKED: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "email-login/blocked",
        message:
            "Authentication has been blocked because the maximum number of attempts has been reached.",
        data: {
            blockUntilDate: 0
        }
    },
    ILLEGAL_OVER_LIMIT: {
        statusCode: HttpStatus.INTERNAL_SERVER_ERROR,
        errorCode: "email-verify/illegal-over-limit",
        message: "An unknown error occurred that exceeded the limit."
    }
} as const;

export const EmailVerifyAPIErrors = {
    CODE_EXPIRED: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "email-verify/expired-code",
        message: "The code has expired."
    },
    BLOCKED: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "email-verify/blocked",
        message:
            "Authentication has been blocked because the maximum number of attempts has been reached.",
        data: {
            blockUntilDate: 0
        }
    },
    INVALID_CODE: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "email-verify/invalid-code",
        message: "Invalid code."
    },
    EMAIL_NOT_SENT: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "email-verify/email-not-sent",
        message: "The email has not been sent yet."
    },
    ILLEGAL_OVER_LIMIT: {
        statusCode: HttpStatus.INTERNAL_SERVER_ERROR,
        errorCode: "email-verify/illegal-over-limit",
        message: "An unknown error occurred that exceeded the limit."
    }
} as const;

export const ChangePhoneNumberAPIErrors = {
    INVALID_PHONE: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "change-phone-number/invalid-phone",
        message: "Phone number is invalid."
    }
} as const;

export const IAPReceiptVerifyAPIErrors = {
    NO_VALID_RECEIPT: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "iap-receipt-verify/no-verified-receipt",
        message: "No verified receipt data available."
    },
    INCORRECT_BUNDLE_ID: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "iap-receipt-verify/incorrect-bundle-id",
        message: "BundleID is invalid."
    },
    INCORRECT_PLATFORM: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "iap-receipt-verify/incorrect-platform",
        message: "Platform is incorrect."
    },
    VERIFY_SERVER_ERROR: {
        statusCode: HttpStatus.INTERNAL_SERVER_ERROR,
        errorCode: "iap-receipt-verify/verify-server-error",
        message: "An error has occurred on the verification server."
    },
    STATUS_CHANGE_ERROR: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "iap-receipt-verify/status-change-error",
        message: "Failed to update billing status."
    },
    ANOTHER_USER_BILLING_ERROR: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "iap-receipt-verify/another-user-billing-error",
        message: "Already paid for by another user."
    },
    NO_PURCHASE_HISTORY: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "iap-receipt-verify/no-purchase-history-error",
        message: "No purchase history."
    }
} as const;

export const TransferToCardAPIErrors = {
    PAYMENT_USER_NOT_FOUND: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "transfer-to-card/payment-user-not-found",
        message: "PaymentUser does not exist."
    },
    PAYMENT_METHOD_INVALID: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "transfer-to-card/payment-method-invalid",
        message: "Current payment method is invalid."
    },
    NOT_PAID: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "transfer-to-card/not-paid",
        message: "This is not a paid period."
    },
    ALREADY_APPLIED: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "transfer-to-card/already-applied",
        message: "Already applied for."
    }
} as const;

export const CancelTransferToCardAPIErrors = {
    PAYMENT_USER_NOT_FOUND: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "cancel-transfer-to-card/payment-user-not-found",
        message: "PaymentUser does not exist."
    },
    PAYMENT_METHOD_INVALID: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "cancel-transfer-to-card/payment-method-invalid",
        message: "Current payment method is invalid."
    },
    NOT_APPLIED: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "cancel-transfer-to-card/not-applied",
        message: "Not applied for transfer."
    }
} as const;

export const PostCounselingReservationAPIErrors = {
    INVALID_FIRST_PREFERRED_TIME: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "post-counseling-reservation/invalid-first-preferred-time",
        message: "First preferred must be selectable time."
    },
    INVALID_SECOND_PREFERRED_TIME: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "post-counseling-reservation/invalid-second-preferred-time",
        message: "Second preferred must be selectable time."
    },
    INVALID_THIRD_PREFERRED_TIME: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "post-counseling-reservation/invalid-third-preferred-time",
        message: "Third preferred must be selectable time."
    },
    INPUT_ONLY_TIME_SECOND_PREFERRED: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "post-counseling-reservation/only-time-second-preferred",
        message: "Second preferred inputted only time."
    },
    INPUT_ONLY_TIME_THIRD_PREFERRED: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "post-counseling-reservation/only-time-third-preferred",
        message: "Third preferred inputted only time."
    },
    DUPLICATE_PREFERRED: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode: "post-counseling-reservation/duplicate-preferred-datetime",
        message: "Preferred datetime duplicate."
    },
    // ↓↓↓↓↓↓ 無料カウンセリング希望日時バリデーションエラー（appで使っている。https://github.com/mationinc/smakon-emb/issues/3042 互換性確保できれば削除)）
    INVALID_FIRST_PREFERRED_DATETIME: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode:
            "post-counseling-reservation/invalid-first-preferred-datetime",
        message: "First preferred must be 3 hours after, and within 7 days."
    },
    INVALID_SECOND_PREFERRED_DATETIME: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode:
            "post-counseling-reservation/invalid-second-preferred-datetime",
        message: "Second preferred must be 3 hours after, and within 7 days."
    },
    INVALID_THIRD_PREFERRED_DATETIME: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode:
            "post-counseling-reservation/invalid-third-preferred-datetime",
        message: "Third preferred must be 3 hours after, and within 7 days."
    },
    // ↑↑↑↑↑↑↑
    // 無料カウンセリング希望日時バリデーションエラー
    INVALID_FREE_FIRST_PREFERRED_DATETIME: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode:
            "post-counseling-reservation/invalid-free-first-preferred-datetime",
        message: "First preferred must be 3 hours after, and within 7 days."
    },
    INVALID_FREE_SECOND_PREFERRED_DATETIME: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode:
            "post-counseling-reservation/invalid-free-second-preferred-datetime",
        message: "Second preferred must be 3 hours after, and within 7 days."
    },
    INVALID_FREE_THIRD_PREFERRED_DATETIME: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode:
            "post-counseling-reservation/invalid-free-third-preferred-datetime",
        message: "Third preferred must be 3 hours after, and within 7 days."
    },
    // 有料登録後面談希望日時バリデーションエラー
    INVALID_AFTER_PAY_FIRST_PREFERRED_DATETIME: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode:
            "post-counseling-reservation/invalid-after-pay-first-preferred-datetime",
        message: "First preferred must be within 7 days."
    },
    INVALID_AFTER_PAY_SECOND_PREFERRED_DATETIME: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode:
            "post-counseling-reservation/invalid-after-pay-second-preferred-datetime",
        message: "Second preferred must be within 7 days."
    },
    INVALID_AFTER_PAY_THIRD_PREFERRED_DATETIME: {
        statusCode: HttpStatus.BAD_REQUEST,
        errorCode:
            "post-counseling-reservation/invalid-after-pay-third-preferred-datetime",
        message: "Third preferred must be within 7 days."
    }
} as const;

export const CommonAPIErrors = {
    FORCED_LOGOUT: {
        statusCode: HttpStatus.FORBIDDEN,
        errorCode: "should-logout-immediately",
        message: "会員ステータスが変更されました。ログアウトします"
    }
} as const;
